import { Button, Modal, Typography } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ReactComponent as CloseButton } from '../assets/images/close_btn.svg';
import { Box } from '@mui/material';
import useScreenSize from '../util/customHooks/useScreenSize';
import { useDispatch, useSelector } from 'react-redux';
import CommonUtil from '../util/CommonUtils';
import { useState } from 'react';
import { clearError } from '../feature/application/appSlice';
import { selectError } from '../feature/application/appSelectors';
import { getApiLastTwoSegment } from '../util/helperFunction';

const GlobalErrorModel = () => {
    const { isMobile, isTablet, isLaptop } = useScreenSize();
    const dispatch = useDispatch();
    const error = useSelector(selectError);
    const [showFull, setShowFull] = useState(false);

    const handleClose = () => {
        dispatch(clearError());
        setShowFull(false);
    };

    const getResponseValue = (response) => {
        if (Array.isArray(response)) {
            return response.join(", ");
        } else if (typeof response === "object" && response !== null) {
            return Object.values(response).join(", ");
        } else {
            return response ?? "";
        }
    };

    const CustomTextField = ({ name, value, ...typographyProps }) => {
        return (
            <Typography style={{ marginBottom: 4, paddingLeft: '24px' }} {...typographyProps}>
                <strong style={{ color: '#cf1322' }}>{name}</strong>{' '}
                <span style={{ color: '#000' }}>
                    {typeof value === 'object'
                        ? JSON.stringify(value, null, 2)
                        : String(value)}
                </span>
            </Typography>
        );
    };


    return (
        <Modal
            title={
                <Box sx={{ display: 'flex', marginTop: '-6px', alignItems: 'center', gap: 1, backgroundColor: "#fff1f0" }}>
                    <ExclamationCircleOutlined style={{ color: '#cf1322' }} />
                    <span style={{ color: '#cf1322', fontSize: '1.2rem', fontWeight: 600 }}>
                        Oops! Something went wrong.
                    </span>
                </Box>
            }
            open={!CommonUtil.isEmpty(error)}
            centered
            width={isMobile ? 350 : isTablet ? 400 : isLaptop ? 500 : 600}
            onCancel={handleClose}
            footer={
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <Button type="link" onClick={() => setShowFull(prev => !prev)} style={{
                        padding: '0px'
                    }}>
                        {showFull ? 'Show Less' : 'Show Details'}
                    </Button>
                </div>
            }
            maskClosable={false}
            closeIcon={<CloseButton />}
            style={{ marginTop: '6%' }}
            className="global-error-modal"
        >
            <div
                style={{
                    width: '100%',
                    overflowY: 'auto',
                    backgroundColor: '#fff1f0'
                }}
            >

                <CustomTextField
                    value={getResponseValue(error?.responseData)}
                    style={{
                        fontSize: '1 rem',
                        fontWeight: 500,
                        paddingLeft: '24px',
                        marginBottom: 4
                    }}
                />

                {
                    showFull && (
                        <>
                            <CustomTextField
                                name="Message:"
                                value={error?.message}
                            />
                            <CustomTextField
                                name="Code:"
                                value={error?.code}
                            />
                            <CustomTextField
                                name="Status:"
                                value={error?.status}
                            />
                            <CustomTextField
                                name="Module:"
                                value={getApiLastTwoSegment(error?.url)}
                            />
                            <CustomTextField
                                name="Date & Time:"
                                value={error?.timestamp}
                            />
                        </>
                    )
                }
            </div>
        </Modal>
    );
};

export default GlobalErrorModel;
